module.exports = __webpack_public_path__ + "img/TPV-L1-4-Pagina1 A.6baa97fe.png";